import React from "react";
import { ArrowRight, Award, BookOpen, Heart } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

export default function About() {
  const credentials = [
    { icon: Award, text: "Integração de abordagens avançadas voltadas ao tratamento de casos complexos" },
    { icon: BookOpen, text: "Atualização contínua baseada em evidências" },
    { icon: Heart, text: "Cuidado centrado na singularidade de cada indivíduo" },
  ];

  return (
    <section id="sobre" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
          <div className="order-2 lg:order-1">
            <ScrollAnimation animation="fade-right">
              <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block">Sobre</span>
            </ScrollAnimation>
            <ScrollAnimation animation="fade-right" delay={100}>
              <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-6 text-balance leading-tight">
                30 anos de experiência em psiquiatria e psicoterapia
              </h2>
            </ScrollAnimation>
            <ScrollAnimation animation="fade-up" delay={200}>
              <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a] mb-5">
                A Mesquita Psiquiatria e Psicoterapia nasceu do encontro entre dois profissionais dedicados a compreender o ser humano em sua totalidade.
              </p>
            </ScrollAnimation>
            <ScrollAnimation animation="fade-up" delay={300}>
              <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a] mb-5">
                Unimos psiquiatria clínica, neurociência e psicoterapia para oferecer um cuidado que vai além do sintoma — enxergando a história, as relações e as experiências que constroem cada pessoa.
              </p>
            </ScrollAnimation>
            <ScrollAnimation animation="fade-up" delay={400}>
              <p className="font-serif text-base sm:text-lg leading-relaxed text-[#698658] font-medium mb-8">
                Nossa missão é acolher, escutar e transformar. Aqui, cada paciente é visto como único, recebendo um plano terapêutico personalizado, fundamentado nas melhores práticas científicas e no respeito à sua trajetória.
              </p>
            </ScrollAnimation>
            <div className="flex flex-col gap-3 mb-8">
              {credentials.map((item, idx) => {
                const Icon = item.icon;
                return (
                  <ScrollAnimation key={idx} animation="fade-right" delay={450 + idx * 80}>
                    <div className="flex items-center gap-3 py-2">
                      <div className="w-10 h-10 rounded-xl bg-[#C2A44A]/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="w-5 h-5 text-[#C2A44A]" />
                      </div>
                      <p className="font-serif text-sm sm:text-base text-[#3d3d3d] leading-relaxed">{item.text}</p>
                    </div>
                  </ScrollAnimation>
                );
              })}
            </div>
            <ScrollAnimation animation="fade-up" delay={700}>
              <a
                href="#abordagem"
                className="inline-flex items-center gap-2 px-6 py-3 bg-[#204613] text-white rounded-xl font-sans font-semibold text-sm sm:text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
              >
                Conheça Nossa Abordagem
                <ArrowRight className="w-4 h-4" />
              </a>
            </ScrollAnimation>
          </div>

          <ScrollAnimation animation="fade-left" delay={300} className="order-1 lg:order-2">
            <div className="relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/mesquita%20%283%29-Bs463K3axHp5ctqA5KM9gx4VX8JBcd.jpg"
                  alt="Maria Inês e Carlos Mesquita"
                  className="w-full h-auto object-cover"
                />
              </div>
              <ScrollAnimation animation="scale" delay={600}>
                <div className="absolute -bottom-4 sm:-bottom-6 -left-2 sm:-left-4 bg-[#f5f0e4] border border-[#C2A44A]/30 rounded-2xl px-4 sm:px-6 py-3 sm:py-4 shadow-lg">
                  <p className="font-sans text-base sm:text-lg font-semibold text-[#204613]">+30 anos</p>
                  <p className="font-serif text-xs sm:text-sm text-[#698658]">de experiência clínica</p>
                </div>
              </ScrollAnimation>
            </div>
          </ScrollAnimation>
        </div>
      </div>
    </section>
  );
}
